
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: this.blok.brands[0]._uid,
      masterTl: {},
      buttonClass:
        'brands-btn slider__item text-blue-500 text-base-semibold h-10 w-[120px] hover:bg-emerald-500 hover:bg-opacity-30 rounded-b-xl mx-2 lg:mx-4 shadow-1',
    }
  },
  computed: {
    tabs() {
      return this.blok.brands
        .map((x) => ({
          id: x._uid,
          label: x.tab,
        }))
        .filter((x) => x.label !== 'default')
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.masterTl = this.$gsap.timeline()
    })
  },
  methods: {
    setSelected(id) {
      this.masterTl
        .to('.brands', {
          autoAlpha: 0,
          duration: 0.2,
          onComplete: () => {
            if (id === this.selected) {
              const defaultBrand = this.blok.brands.find(
                (x) => x.tab === 'default'
              )
              this.selected = defaultBrand._uid || ''
            } else {
              this.selected = id
            }
          },
        })
        .to('.brands', {
          autoAlpha: 1,
          duration: 0.2,
        })
    },
  },
}
